/**
 * @file CustomerProfileSection.tsx
 * @description Карточка профиля клиента (phase08.5 shadcn).
 */

import { useEffect, useState } from "react";

import { EditorialCard } from "../../../../components/ui/EditorialCard";
import {
  legalEntities,
  type CustomerDto,
  type LegalEntityDto,
} from "../../../../lib/api-customers";
import { formatPhone } from "../../../../lib/phone-format";

interface Props {
  customer: CustomerDto;
}

export function CustomerProfileSection({ customer }: Props) {
  const [legalEntity, setLegalEntity] = useState<LegalEntityDto | null>(null);

  useEffect(() => {
    if (customer.legalEntityId) {
      void legalEntities
        .findOne(customer.legalEntityId)
        .then(setLegalEntity)
        .catch(() => setLegalEntity(null));
    } else {
      setLegalEntity(null);
    }
  }, [customer.legalEntityId]);

  return (
    <EditorialCard>
      <EditorialCard.Body>
        <div className="label-editorial mb-3">Контактная информация</div>
        <div className="flex flex-col gap-3">
          {customer.displayName ? (
            <Field label="ФИО / Контактное лицо" value={customer.displayName} />
          ) : null}
          {customer.email ? <Field label="Email" value={customer.email} /> : null}
          {customer.phone ? <Field label="Телефон" value={formatPhone(customer.phone)} /> : null}
        </div>

        {legalEntity ? (
          <div className="mt-5 pt-4 [box-shadow:inset_0_1px_0_var(--outline-variant)]">
            <div className="label-editorial mb-3">Юр.лицо</div>
            <div className="flex flex-col gap-3">
              <Field label="Наименование" value={legalEntity.displayName} />
              <Field label="ИНН" value={legalEntity.inn} />
              {legalEntity.kpp ? <Field label="КПП" value={legalEntity.kpp} /> : null}
              {legalEntity.ogrn ? <Field label="ОГРН" value={legalEntity.ogrn} /> : null}
              <Field label="Юр.адрес" value={legalEntity.legalAddress} />
            </div>
          </div>
        ) : null}
      </EditorialCard.Body>
    </EditorialCard>
  );
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="text-xs text-on-surface-variant">{label}</div>
      <div className="text-sm text-on-surface">{value}</div>
    </div>
  );
}
